<div class="mainContent">
  <div class="pageHeader">Region Info</div>
  <div class="column-Layout">
    <div class="firstDivision">
      <div class="topCategory">
        <mat-card>
          <mat-card-header>           
            <mat-card-title i18n>Details</mat-card-title>
            <mat-card-subtitle i18n>
              Basic information
            </mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <mat-list class="itemInfo">
              <div mat-line>
                <mat-list-item i18n class="itemQuestion"> Name </mat-list-item>
                <mat-list-item role="listitem" class="itemAnswer"> {{selectedRegionMetaData.name}}</mat-list-item>
              </div>
              <!-- <div mat-line>
                <mat-list-item i18n class="itemQuestion"> Area </mat-list-item>
                <mat-list-item role="listitem" class="itemAnswer"> {{selectedRegionMetaData.area}} <p class="superscriptSymbol">km<sup>2</sup></p></mat-list-item>
              </div> -->
              <div mat-line>
                <mat-list-item i18n class="itemQuestion"> No. of Buildings </mat-list-item>
                <mat-list-item role="listitem" class="itemAnswer"> {{selectedRegionMetaData.numberOfBuilding}}</mat-list-item>
              </div>
              <div mat-line>
                <mat-list-item i18n class="itemQuestion"> No. of Ducts </mat-list-item>
                <mat-list-item role="listitem" class="itemAnswer"> {{selectedRegionMetaData.numberOfDuct}}</mat-list-item>
              </div>
              <div mat-line>
                <mat-list-item i18n class="itemQuestion"> No. of Cables </mat-list-item>
                <mat-list-item role="listitem" class="itemAnswer">{{selectedRegionMetaData.numberOfCable}} </mat-list-item>
              </div>
              <div mat-line>
                <mat-list-item i18n class="itemQuestion"> No. of Racks </mat-list-item>
                <mat-list-item role="listitem" class="itemAnswer">{{selectedRegionMetaData.numberOfRack}} </mat-list-item>
              </div>
              <div mat-line>
                <mat-list-item i18n class="itemQuestion"> No. of Components </mat-list-item>
                <mat-list-item role="listitem" class="itemAnswer">{{selectedRegionMetaData.numberOfComponent}} </mat-list-item>
              </div>             
              <!-- <div mat-line>
                <mat-list-item i18n class="itemQuestion"> No. of Redlinings</mat-list-item>
                <mat-list-item role="listitem" class="itemAnswer">{{selectedRegionMetaData.numberOfRedlinings}} </mat-list-item>
              </div> -->
            </mat-list>
          </mat-card-content>
        </mat-card>

          <mat-card class="detail-user">
            <mat-card-header>
              <mat-card-title class="actionButton">
                <button mat-button i18n-matTooltip matTooltip="Set validity" (click)="setDataValidity()">             
                  <mat-icon>playlist_add_check</mat-icon>
                </button>      
                <button mat-button i18n-matTooltip matTooltip="Display Options"  (click)="setDisplayPermissions()">
                  <mat-icon class="displayIcon">group</mat-icon>
                </button>       
              </mat-card-title>
              <mat-card-title i18n>Assigned Users</mat-card-title>
              <mat-card-subtitle i18n>
                Users with this region assigned
              </mat-card-subtitle>
              <mat-card-subtitle>
                <mat-form-field class="my-form-field regionFilterField">
                  <mat-label>Filter</mat-label>
                  <input matInput (keyup)="applyFilter($event)" #input>
                </mat-form-field>
                <div class="container" class="tableInfo">
                  <table mat-table [dataSource]="userDataSource" matSort>
                    <ng-container matColumnDef="select">
                      <th mat-header-cell *matHeaderCellDef></th>
                      <td mat-cell *matCellDef="let row">
                        <mat-checkbox (click)="$event.stopPropagation()"
                          (change)="$event ?selectionModel.toggle(row)||add(row,$event) : null"
                          [checked]="selectionModel.isSelected(row)">
                        </mat-checkbox>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Name </th>
                      <td mat-cell *matCellDef="let element" class="nameSeparation"> {{element.name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="role">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Role </th>
                      <td mat-cell *matCellDef="let element"> {{element.role}} </td>
                    </ng-container>

                    <ng-container matColumnDef="domain">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Domain </th>
                      <td mat-cell *matCellDef="let element"> {{element.domain}} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedUserColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedUserColumns;" (click)="selectionModel.toggle(row)">
                    </tr>
                  </table>
                </div>
              </mat-card-subtitle>
            </mat-card-header>
          </mat-card>
      </div>

      <div class="detail-main">
        <mat-card>
          <mat-card-header>
            <mat-card-title class="actionButton">
              <section>               
                <button mat-button class="sec-btn" matTooltip="Cache" (click)="startCache()" [disabled]="isCacheDisabled">
                  <mat-icon class="qr">layers</mat-icon>
                </button>               
                <button mat-button class="sec-btn" i18n-matTooltip matTooltip="Reset Cache" (click)="startReCache()" [disabled]="isReCacheDisabled" >
                  <mat-icon class="qr">layers_clear</mat-icon>
                </button>
              </section>
            </mat-card-title>
            <mat-card-title>Cache</mat-card-title>
            <mat-card-subtitle i18n>
              Caching set-up
            </mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <div>
              <div class="cacheFrequencyBox">
                <label class="frequencyText" i18n>Select frequency</label> 
                <mat-radio-group aria-label="Select an option" class="radioOptions" (change)="radioChange($event)" [(ngModel)]="cacheFrequency" [value]="cacheFrequency">
                  <mat-radio-button value="1">
                    <span class="wrap-mat-radio-label" i18n>One-time</span>
                  </mat-radio-button>
                  <mat-radio-button value="2">
                    <span class="wrap-mat-radio-label" i18n>Weekly</span>
                  </mat-radio-button>
                  <mat-radio-button value="3">
                    <span class="wrap-mat-radio-label" i18n>Daily</span>
                  </mat-radio-button>                 
                </mat-radio-group>
              </div>
              <section class="tm" *ngIf ="hideDayTime">
                <mat-form-field class="my-form-field" appearance="none">
                  <mat-label i18n>Select Time</mat-label>
                  <input matInput type="time" title="true" [(ngModel)]="cacheTime" [value]="cacheTime" placeholder={{startTime}} (change)="applyChanges($event)">
                </mat-form-field>

                <mat-form-field class="my-form-field" appearance="none" *ngIf ="hideWeekDays">
                  <mat-label i18n>Select Day</mat-label>
                  <mat-select matNativeControl [(ngModel)]="cacheDay" [value]="cacheDay" (selectionChange)="applyChanges($event)">                                 
                    <mat-option value="Monday" i18n>Monday</mat-option>
                    <mat-option value="Tuesday" i18n>Tuesday</mat-option>
                    <mat-option value="Wednesday" i18n>Wednesday</mat-option>
                    <mat-option value="Thursday" i18n>Thursday</mat-option>
                    <mat-option value="Friday" i18n>Friday</mat-option>
                    <mat-option value="Saturday" i18n>Saturday</mat-option>
                    <mat-option value="Sunday" i18n>Sunday</mat-option>
                  </mat-select>
                </mat-form-field>               
              </section>

              <section class="prg">
                <mat-progress-bar class="progressLine" mode="determinate" value={{percentage}} bufferValue="100" />
                <label class="progressIndicator">{{precentageText}}</label>
              </section>

              <section>
                <p class="statusInfo"><mat-icon class="statusInfoIcon">info_outline</mat-icon> {{statusText}}</p>
              </section>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <div class="detail-map">
      <div id="map" class="map">
      </div>
    </div>
</div>
</div>
